// extracted by mini-css-extract-plugin
module.exports = {"featuresReviewHeader":"ProductFeaturesReviews_featuresReviewHeader__kZGyj","reviewSummaryWrapper":"ProductFeaturesReviews_reviewSummaryWrapper__e7MpD"};